import { UrlMatchResult, UrlSegment } from '@angular/router';

export function ifuProductsCategoryMatcher(segment: UrlSegment[]): UrlMatchResult {
  if (
    segment.length > 2 &&
    (segment[0].path === 'instructions-for-use' || segment[1].path === 'instructions-for-use') &&
    segment[segment.length - 2].path === 'csc' &&
    segment[segment.length - 1].path !== 'products'
  ) {
    const posParams = {
      categoryCode: segment[segment.length - 1]
    };
    if (segment[0].path !== 'instructions-for-use') {
      posParams['brand'] = segment[0];
    }
    return { consumed: segment, posParams: posParams };
  }
  return null;
}
